
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import store from '../vuex/store'
export default {
components: {
Group,
Cell
},
data () {
return {




msg: 'Hello World!'
}
},
dialogHide () {
store.commit('UPDATE_SHOW_FOOTER', true)
},
mounted () {
store.commit('UPDATE_TITLE', '发票夹')
}
}



// WEBPACK FOOTER //
// ./src/components/home.vue